import { useIntl } from "react-intl";
import { IBulkCreateSerialError } from "@models/DTO/IOnBulkCreateSerialsDTO";

/** Most skipped values listed; the rest are summarised as "...and N more". */
const MAX_LISTED = 20;

type Props = {
    created: number;
    skipped: IBulkCreateSerialError[];
};

/**
 * Outcome of a bulk serial create that skipped some values (OR-1550): how many were created and which values
 * were not, with the reason (e.g. "Serial already exists").
 */
export const BulkCreateSerialsOutcome = ({ created, skipped }: Props) => {
    const intl = useIntl();
    const listed = skipped.slice(0, MAX_LISTED);

    return (
        <div className="alert alert-warning py-2 small" data-testid="bulk-create-serials-outcome">
            <div className="fw-bold mb-1">
                {intl.formatMessage(
                    {
                        id: "bulk_create_serials_outcome",
                        defaultMessage: "Created {created} of {total} serials. Not created:",
                    },
                    { created, total: created + skipped.length }
                )}
            </div>
            <ul className="mb-0 ps-3">
                {listed.map((item, index) => (
                    <li key={`${item.serial}-${index}`}>
                        {item.serial ? <span className="font-monospace">{item.serial}</span> : null}
                        {item.serial ? ": " : null}
                        {item.reason}
                    </li>
                ))}
            </ul>
            {skipped.length > listed.length && (
                <div className="mt-1">
                    {intl.formatMessage(
                        { id: "and_n_more", defaultMessage: "...and {count} more" },
                        { count: skipped.length - listed.length }
                    )}
                </div>
            )}
        </div>
    );
};
